export default "__VITE_ASSET__B0_hYRUj__ 1920w";